// extracted by mini-css-extract-plugin
export default {"GuidedTourSwitcher":"GuidedTourSwitcher_qImXe"};